import {Location, isCountry, locationId, locationName} from '@shared/models/location';
import {Row, ScrollView, Text} from 'native-base';
import BottomsheetProps from '@ui/components/sheet/BottomsheetProps';
import BottomsheetWamp from '@ui/components/sheet/Bottomsheet';
import Flag from '@ui/components/flag/Flag';
import React from 'react';
import {TouchableOpacity} from 'react-native';
import {useTranslation} from 'react-i18next';

interface Props extends Omit<BottomsheetProps, 'children'>{
    selectedLocation?: Location;
    setLocation: (location: Location) => void;
    locations: Location[];
}

const LocationModal = (props:Props) => {
    const {setLocation} = props;
    const {t} = useTranslation();

    return (
        <BottomsheetWamp {...props} _bottomSheetProps={{snapPoints: ['90%']}} title={t('competition.detail.selectLocation')}>
            <Text variant='bodyLg' p='4'>{t('competition.detail.selectLocationDescription')}</Text>

            <ScrollView>
                {props.locations.sort((a, b) => locationName(a).localeCompare(locationName(b))).map(location => (
                    <TouchableOpacity key={locationId(location)} onPress={() => setLocation(location)}>
                        <Row px='4' py='1' space='2' alignItems='center'>
                            {isCountry(location) && <Flag country={location.countryCode} />}

                            <Text variant='bodyLg'>{locationName(location)}</Text>
                        </Row>
                    </TouchableOpacity>
                ))}
            </ScrollView>
        </BottomsheetWamp>
    );
};

export default LocationModal;
